import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom';
import BusinessPlanPage from './pages/BusinessPlanPage';
import ContactPage from './pages/ContactPage';
import InvestorDemoPage from './pages/DemoPage';
import HomePageClient from './pages/HomePageClient';
import InvestorPage from './pages/InvestorPage';
import Navbar from './pages/Navbar';
import PitchDeckPage from './pages/PitchDeckPage';
import VisitLogger from './VisitLogger';
import BookDemoPage from './pages/BookDemoPage';

/* ───── App ───── */

const App: React.FC = () => (
  <Router basename={process.env.PUBLIC_URL}>
    <Navbar />
    <VisitLogger />
    <Routes>
      <Route path="/" element={<HomePageClient />} />
      <Route path="/investor" element={<InvestorPage />} />
      <Route path="/investor/demo" element={<InvestorDemoPage />} />
      <Route path="/investor/business-plan" element={<BusinessPlanPage />} />
      <Route path="/investor/pitch-deck" element={<PitchDeckPage />} />
      <Route path="/book-demo" element={<BookDemoPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  </Router>
);

export default App;